import { useState, useEffect, useCallback } from 'react'
import { doRequestGet } from '../../api';
import { doToast } from '../../utils';
import { toast } from 'react-toastify'

export const useGetId = ({
  url, rowId
}) => {
  const [error, setError] = useState(false);
  const [isProcessing, setIsProccesing] = useState(true)
  const [getRow, setGetRow] = useState({})

  const fetchData = useCallback(async () => {
    try {
      if (rowId) {
        const row = await doRequestGet({
          url: url
        })

        if (row.response === 'success') {
          setGetRow(row.data)
          setIsProccesing(false);
        } else {
          setGetRow({})
          setError(true)
          setIsProccesing(false)
          doToast({
            ...row,
            toast
          })
        }
      } else {
        setIsProccesing(false);
      }
    } catch (error) {
      setGetRow({})
      setError(true)
      setIsProccesing(false)
    }
  }, [url, rowId])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    getRow,
    isProcessing,
    error
  }
}